import React from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import MascotPlaceholder from "@/components/MascotPlaceholder";
import { GoogleLogo } from "@phosphor-icons/react";

export default function Login() {
  const { t } = useApp();
  const location = useLocation();
  // Default post-login landing is now the checklist (Organizza la partenza).
  // Deep-link callers (Dashboard, protected pages) still pass their own
  // `after` via location.state and that takes priority.
  const after = location.state?.after || "/organizza";

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + after;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] max-w-md mx-auto px-5 py-10 flex flex-col items-center justify-center text-center">
      <MascotPlaceholder emotion="happy" size="hero" src="/assets/boardy-orgoglioso.png" className="mb-6" />
      <h1 className="font-display font-black text-3xl sm:text-4xl text-ink tracking-tight">
        {t.modes.organizzativa.loginParentTitle}
      </h1>
      <p
        data-testid="login-parent-body"
        className="text-ink-soft mt-3 leading-relaxed"
      >
        {t.modes.organizzativa.loginParentBody}
      </p>

      <Button
        data-testid="google-signin-btn"
        onClick={signIn}
        className="mt-8 h-12 rounded-full bg-ink hover:bg-ink/90 text-white font-sans font-semibold px-6"
      >
        <GoogleLogo size={20} weight="bold" className="mr-2" />
        {t.nav.login} · Google
      </Button>
    </div>
  );
}
